/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class CalendarService {
  /**
   * Get Google Auth Url
   * Get the authorization URL for the client to visit.
   * @returns string Successful Response
   * @throws ApiError
   */
  public static getGoogleAuthUrl(): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/calendar/google/auth_url",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Internal Server Error`,
      },
    });
  }

  /**
   * Enable Google Calendar
   * Enable the google calendar API for an account.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static enableGoogleCalendar({
    code,
  }: {
    code: string;
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/calendar/google/enable",
      query: {
        code: code,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        422: `Validation Error`,
        500: `Internal Server Error`,
      },
    });
  }

  /**
   * Revoke Google Calendar
   * Revoke Tadpole's access to a google account.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static revokeGoogleCalendar(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/calendar/google/revoke",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        500: `Internal Server Error`,
      },
    });
  }
}
